import { useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const navLinks = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#FFFDF5] border-b-[3px] border-[#0A0A0A] shadow-[0_4px_0px_#0A0A0A]"
    >
      <div className="px-6 md:px-12 lg:px-24 flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          aria-label="Corcoran Design — back to top"
          className="font-heading text-xl md:text-2xl tracking-tighter text-[#0A0A0A] uppercase"
        >
          Corcoran<span className="text-[#FE4A90]">.</span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="font-mono text-sm uppercase tracking-widest font-bold text-[#0A0A0A] hover:text-[#FE4A90] transition-colors duration-150"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta"
            className="brutal-btn bg-[#FE4A90] text-white px-5 py-2 text-sm"
          >
            Let's Talk
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="md:hidden bg-[#FFFDF5] border-b-[3px] border-[#0A0A0A] overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="font-mono text-lg uppercase tracking-widest font-bold text-[#0A0A0A] hover:text-[#FE4A90]"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="brutal-btn bg-[#FE4A90] text-white px-5 py-3 text-center text-sm mt-2"
              >
                Let's Talk
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
